import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Body, Heading } from '../../typography';

const AssignmentExpired = ({ assignment }) => {
    const date = moment(assignment.endDate).format('DD/MM/YYYY');
    const time = moment(assignment.endDate).format('hh:mm');

    return (
        <>
            <Heading level={2} weight="light">
                {'Non puoi più svolgere questa prova'}
            </Heading>
            <br />
            <Body>{`Potevi svolgere la prova entro il ${date} alle ${time}.`}</Body>
            <br />
            <Body>{`Hai bisogno di aiuto? Contattaci`}</Body>
            <br />
        </>
    );
};

AssignmentExpired.propTypes = {
    assignment: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        assignment: state.assignment,
    };
}

export default connect(mapStateToProps)(AssignmentExpired);
